import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { Box } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// components
import { useSettingsContext } from "../../components/settings";
//
import Main from "./Main";
import Header from "./header";
import NavMini from "./nav/NavMini";
import NavVertical from "./nav/NavVertical";
import { useMutation } from "@apollo/client";
import { userUpdate } from "../../graphql";
import { CURRENT_USER_QUERY, useAuthContext } from "../../sections/auth";
import axios from "axios";

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();

  const isDesktop = useResponsive("up", "lg");

  const [open, setOpen] = useState(false);
  const get_sms_access_token = localStorage.getItem("ring_central_token");
  const get_sms_user_data = localStorage.getItem("ring_central_user_data");
  const get_sms_refresh_token = localStorage.getItem(
    "ring_central_refresh_token"
  );
  const get_outlook_access_token = localStorage.getItem("outlook_access_token");
  const get_outlook_refresh_token = localStorage.getItem(
    "outlook_refresh_token"
  );
  const get_google_access_token = localStorage.getItem("google_access_token");
  const get_google_refresh_token = localStorage.getItem("google_refresh_token");
  const get_outlook_code = localStorage.getItem("outlook_code");

  const { user } = useAuthContext();
  const [UpdateUser, { loading: updateUserLoading }] = useMutation(userUpdate, {
    refetchQueries: [
      {
        query: CURRENT_USER_QUERY,
      },
    ],
  });

  const isNavMini = themeLayout === "mini";

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = (
    <NavVertical openNav={open} onCloseNav={handleClose} />
  );

  // useEffect(() => {
  //   if (user) {
  //     UpdateUser({
  //       variables: {
  //         data: {
  //           id: user.id,
  //           access_token_data: {
  //             google_access_token: get_google_access_token
  //               ? get_google_access_token
  //               : "",
  //             google_refresh_token: get_google_refresh_token
  //               ? get_google_refresh_token
  //               : "",
  //             outlook_access_token: get_outlook_access_token
  //               ? get_outlook_access_token
  //               : "",
  //             outlook_refresh_token: get_outlook_refresh_token
  //               ? get_outlook_refresh_token
  //               : "",
  //             sms_access_token: get_sms_access_token
  //               ? get_sms_access_token
  //               : "",
  //             sms_refresh_token: get_sms_refresh_token
  //               ? get_sms_refresh_token
  //               : "",
  //             sms_user_data: get_sms_user_data
  //               ? JSON.parse(get_sms_user_data)
  //               : "",
  //             mailchimp_user_field_mapping: "",
  //           },
  //         },
  //       },
  //     });
  //   }
  // }, [
  //   get_sms_access_token,
  //   get_outlook_access_token,
  //   get_outlook_refresh_token,
  //   get_google_access_token,
  //   get_google_refresh_token,
  //   get_sms_refresh_token,
  //   get_sms_user_data,
  //   user,
  // ]);

  // useEffect(() => {
  //   if (get_outlook_code) {
  //     axios
  //       .post(
  //         `${process.env.REACT_APP_OUTLOOK_URL}/token`,
  //         {
  //           client_id: process.env.REACT_APP_OUTLOOK_CLIENT_ID,
  //           scope: "openid offline_access mail.read User.Read mail.send",
  //           code: get_outlook_code,
  //           redirect_uri: `${process.env.REACT_APP_LIVE_URL}/setting`,
  //           grant_type: "authorization_code",
  //           code_verifier: process.env.REACT_APP_OUTLOOK_CODE_VERIFIER,
  //         },
  //         { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  //       )
  //       .then((res) => {
  //         UpdateUser({
  //           variables: {
  //             data: {
  //               id: user.id,
  //               access_token_data: {
  //                 google_access_token: "",
  //                 google_refresh_token: "",
  //                 outlook_access_token: res.data?.access_token,
  //                 outlook_refresh_token: res.data?.refresh_token,
  //                 sms_access_token: get_sms_access_token
  //                   ? get_sms_access_token
  //                   : "",
  //                 sms_refresh_token: get_sms_refresh_token
  //                   ? get_sms_refresh_token
  //                   : "",
  //               },
  //             },
  //           },
  //         });
  //         localStorage.removeItem("outlook_code");
  //         localStorage.removeItem("google_access_token");
  //         localStorage.removeItem("google_refresh_token");
  //         localStorage.setItem("outlook_access_token", res.data.access_token);
  //         localStorage.setItem("outlook_refresh_token", res.data.refresh_token);
  //       });
  //   }
  // }, [get_outlook_code]);

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: "flex" },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }
  return (
    <>
      <Header onOpenNav={handleOpen} />
      {/* {!isDesktop && (
        <Box
          sx={{
            // height: 1,
            px: { lg: 5 },
          }}
        >
          <IconButton
            onClick={handleOpen}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Iconify icon="eva:menu-2-fill" />
          </IconButton>
        </Box>
      )} */}
      <Box
        sx={{
          display: { lg: "flex" },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
